import { render, staticRenderFns } from "./Activity_suggestions.vue?vue&type=template&id=07d5b5e6"
import script from "./Activity_suggestions.vue?vue&type=script&lang=js"
export * from "./Activity_suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports